import { hierarchy, tree, cluster } from "d3-hierarchy";

const algorithm = "tree";

export const makeTree = (data, width) => {
  const root = hierarchy(data);
  root.dx = 20;
  root.dy = width / (root.height + 1);

  let layout;
  switch (algorithm) {
    case "cluster":
      layout = cluster();
      break;
    case "cluster-no-separation":
      layout = cluster().separation(() => 1);
      break;
    case "tree":
      layout = tree();
      break;
    default:
      layout = tree();
  }
  return layout.nodeSize([root.dx, root.dy])(root);
};

// Drawing
export const getBuildLinePath = yOffset => d => `
        M${d.target.y},${d.target.x}
        C${d.source.y + yOffset},${d.target.x}
         ${d.source.y + yOffset},${d.source.x}
         ${d.source.y},${d.source.x}
      `;

export const buildLinePathStraight = d => `
        M${d.target.y},${d.target.x}
        L${d.source.y},${d.source.x}
      `;


// DrawCrossLinks
// Basic straight line, no bezier curve
export const buildCrosslink = pair => {
  const [start, end] = pair;
  if (pair.some(item => item === undefined)) {
    return ''
  }
  return `
        M${start.y},${start.x}
        L${end.y},${end.x}
      `;
};

const pub = {
  makeTree,
  buildCrosslink,
  getBuildLinePath,
  buildLinePathStraight
}

export default pub;
